(() => {
  const debugKey = 'emerdepot-cls-debug';

  if (localStorage.getItem(debugKey) !== '1' || !('PerformanceObserver' in window)) {
    return;
  }

  const describeNode = (node) => {
    if (!(node instanceof Element)) return '(no attributed element)';

    const id = node.id ? `#${node.id}` : '';
    const classes = Array.from(node.classList).slice(0, 3).map((name) => `.${name}`).join('');
    return `${node.tagName.toLowerCase()}${id}${classes}`;
  };

  const describeRect = (rect) => `${Math.round(rect.x)},${Math.round(rect.y)} ${Math.round(rect.width)}x${Math.round(rect.height)}`;

  let cumulativeScore = 0;

  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (entry.hadRecentInput) continue;

      cumulativeScore += entry.value;
      const sources = entry.sources.map((source) => ({
        element: describeNode(source.node),
        previous: describeRect(source.previousRect),
        current: describeRect(source.currentRect)
      }));

      console.groupCollapsed(`[CLS] ${entry.value.toFixed(4)} at ${Math.round(entry.startTime)} ms; total ${cumulativeScore.toFixed(4)}`);
      console.table(sources);
      console.groupEnd();
    }
  });

  observer.observe({ type: 'layout-shift', buffered: true });
  console.info('[CLS] Attribution enabled. Reload once, then inspect the [CLS] groups after the page settles.');
})();
